exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mortgage-progress-show-item-component[data-v-14f158cc] {\n  padding: 8px 8px 8px 16px;\n  border-bottom: 1px solid #e8e8e8;\n}\n.mortgage-progress-show-item-component[data-v-14f158cc]:last-child {\n  border-bottom: none;\n}\n.mortgage-progress-show-item-component .delete-button[data-v-14f158cc] {\n  margin: -2px;\n}\n.mortgage-progress-show-item-component .small[data-v-14f158cc] {\n  color: #333;\n}\n.mortgage-progress-show-item-component .small .green[data-v-14f158cc] {\n  color: green;\n}\n.mortgage-progress-show-item-component .small .red[data-v-14f158cc] {\n  color: #870000;\n}\n", ""]);

// exports
